import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Select,
  Spin,
  message,
  Button,
  Table,
  Space,
  Modal,
  Typography,
  Tag,
  Input,
} from "antd";
import { PlusOutlined, EyeOutlined, UserOutlined } from "@ant-design/icons";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { readItems } from "@directus/sdk";

import CreateSalesmanTroops from "./components/CreateSalesmanTroops";
import LoanDetailsModal from "../loans_routes/components/LoanDetailsModal";
import { Link } from "react-router-dom";

const { Title } = Typography;
const { Search } = Input;

const SalesmanTroops = () => {
  const user = useSelector((state) => state.userdata.id);

  const [troopLoans, setTroopLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);

  const fetchTroopLoans = async () => {
    setLoading(true);
    try {
      const directus = await getDirectusClient();

      const response = await directus.request(
        readItems("prestamos_tropas", {
          fields: [
            "*",
            "vendedor.id",
            "vendedor.first_name",
            "vendedor.role.name",
            "vendedor.rol.last_name",
            "seriales.seriales_id.*",
            "seriales.seriales_id.producto.*",
            "seriales.seriales_id.producto.grupo.*",
            "inventario_nsp.inventario_ns_prestamo_id.id",
            "inventario_nsp.inventario_ns_prestamo_id.inventario_ns.nombre",
            "inventario_nsp.inventario_ns_prestamo_id.estado",
            "inventario_nsp.inventario_ns_prestamo_id.cantidad",
          ],
          filter: {
            _and: [
              {
                vendedor: {
                  superior: { _eq: user },
                },
              },
            ],
          },
          sort: ["-date_created"],
        })
      );

      setTroopLoans(response);
    } catch (error) {
      console.error("Error fetching troop loans:", error);
      message.error("Error al cargar los préstamos de tropas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTroopLoans();
  }, [user]);

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const getStatusColor = (status) => {
    const colors = {
      solicitud_prestamo: "blue",
      activo: "green",
      anulado: "red",
      cerrado: "gray",
      devolucion: "orange",
    };
    return colors[status] || "gold";
  };

  const columns = [
    {
      title: "Vendedor",
      dataIndex: ["vendedor", "first_name"],
      key: "vendedor",
      render: (text, record) =>
        `${record.vendedor?.first_name || ""} ${
          record.vendedor?.last_name || ""
        }`,
    },
    {
      title: "Fecha",
      dataIndex: "date_created",
      key: "date",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      key: "tipo",
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      render: (estado) => (
        <Tag color={getStatusColor(estado)}>{estado || "pendiente"}</Tag>
      ),
    },
    {
      title: "# Seriales",
      key: "seriales",
      render: (_, record) => record.seriales?.length || 0,
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            size="small"
            icon={<EyeOutlined />}
            onClick={() => {
              setSelectedLoan(record);
              setDetailsModalVisible(true);
            }}
          >
            Ver detalles
          </Button>
        </Space>
      ),
    },
  ];

  const filteredTroopLoans = troopLoans.filter((loan) => {
    if (!searchText) return true;
    const vendedorName =
      `${loan.vendedor?.first_name} ${loan.vendedor?.last_name}`.toLowerCase();
    return vendedorName.includes(searchText.toLowerCase());
  });

  return (
    <Layouts>
      <div style={{ padding: "20px" }}>
        <Space>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setCreateModalVisible(true)}
          >
            Crear Préstamo de Tropas
          </Button>
          <Link to="/salesman-troops-repay">
            <Button color="default" variant="outlined">Devolver prestamos</Button>
          </Link>
          
          <Search
            placeholder="Buscar por vendedor"
            allowClear
            onSearch={handleSearch}
            style={{ width: 300 }}
            enterButton
          />
        </Space>

     

        <Table
          columns={columns}
          dataSource={filteredTroopLoans}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `Total: ${total} préstamos`,
          }}
        />

        <Modal
          title="Crear Préstamo de Tropas"
          open={createModalVisible}
          onCancel={() => setCreateModalVisible(false)}
          footer={null}
          width={1200}
          destroyOnClose
        >
          <CreateSalesmanTroops
            onSuccess={() => {
              setCreateModalVisible(false);
              fetchTroopLoans();
            }}
          />
        </Modal>

        <LoanDetailsModal
          visible={detailsModalVisible}
          onCancel={() => {
            setDetailsModalVisible(false);
            setSelectedLoan(null);
          }}
          selectedLoan={selectedLoan}
          tipo="tropas"
        />
      </div>
    </Layouts>
  );
};

export default SalesmanTroops;
